import { ChangeDetectionStrategy, Component, ElementRef, forwardRef, Input, OnInit, Renderer2 } from '@angular/core';

import { IsWithinModalService } from 'src/app/core/services/is-within-modal/is-within-modal.service';

import { FootnoteHintComponent, IN_MODAL_IDENTIFIER } from '../footnote-hint/footnote-hint.component';
import { FootnoteHint } from '../footnote-hint/footnote-hint.enum';

@Component({
  selector: 'cc-footnote-rrp-hint',
  templateUrl: './footnote-hint-rrp.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // TODO: Fix with MBCC-2650
  // remove forwardRef when underlying issue is fixed
  // eslint-disable-next-line @angular-eslint/no-forward-ref
  imports: [forwardRef(() => FootnoteHintComponent)]
})

/**
 * RRP Recommended Retail Price: Footnote hint for market CH display beyond every price with (UVP)
 * To enable the component to work in the modal and outside without knowing the ModuleId and to pass it through several components.
 */
export class FootnoteHintRRPComponent implements OnInit {
  @Input() public isWithinModal = false;
  @Input() public component = '';
  @Input() public isNotInteractive = false;

  public readonly footnoteHint = FootnoteHint.RRPrice;

  public constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly renderer: Renderer2,
    private readonly isWithinModalService: IsWithinModalService
  ) {}

  public ngOnInit(): void {
    if (!this.isWithinModal) {
      // TODO: Find out why this tries to write to window.parent (WTF?)
      // eslint-disable-next-line no-restricted-globals, no-global-assign
      parent = this.renderer.parentNode(this.elementRef.nativeElement) as Window;
      this.isWithinModal = !!this.isWithinModalService.checkElement(this.elementRef);
      this.component = IN_MODAL_IDENTIFIER;
    }
  }
}
